import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCalendarDays } from "@fortawesome/free-solid-svg-icons";

const CssTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    fontSize: "0.9rem",
    color: "#666",
    backgroundColor: "#fff",
    // fontFamily: "Inter",

    top: "2px",
    "& .required": {
      color: "#f00",
      paddingLeft: "2px",
      fontSize: "16px",
    },
  },
  "& label.Mui-focused": {
    color: "rgba(0, 79, 158, 1)",
    // fontFamily: "Inter",
    // fontWeight: '600',
    top: "0px",
  },
  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled": {
    '-webkit-text-fill-color': 'rgba(0,0,0,0.7)'
  },
  "& .Mui-disabled": {
    background: "#f1f1f5",
    color: "#202020 !important",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff",
    height: "44px",

    "& fieldset": {
      borderColor: "#a6a8ab",
    },
    "&:hover fieldset": {
      borderColor: "#a6a8ab",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#004F9E",
    },

    "& input[type=number]": {
      MozAppearance: "textfield",
      padding: "9px 9px",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
});

function TextBox(props) {
  const {
    type,
    label = "",
    value = "",
    onChange = null,
    disabled = false,
    name,
    isCompulsory = false,
    calIcon = false,
    rssign = false,
    textBoxRef,
    adornment,
    style,
    onBlur = null,
    maxLength = "",
    autoFocus = false,
    onKeyDown,
    isSpecficText = false,
    regePattern = "",
    id = '',
    changeCase = true,
    onFocus = null
  } = props;

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    // Focus on the text field if autoFocus is true
    if (autoFocus && textBoxRef && textBoxRef.current) {
      textBoxRef.current.focus();
    }
  }, [autoFocus, textBoxRef]);
  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(changeCase ? value?.toString()?.toUpperCase() : value?.toString());
    }
  }, [value]);

  const handleInputOnChange = (e) => {
    let newVal = changeCase ? e.target.value.toString()?.toUpperCase() : e.target.value;
    if (isSpecficText && regePattern !== '') {
      let checkText = new RegExp(regePattern);
      if (checkText.test(newVal) || newVal?.trim() === '') {
        handleValue(e, newVal)
      }
    } else {
      handleValue(e, newVal)
    }
  };
  const handleValue = (e, newVal) => {
    if (maxLength) {
      if (newVal.length <= maxLength) {
        setInputValue(newVal);
        if (onChange) {
          const syntheticEvent = {
            target: {
              value: newVal,
              name: e.target.name,
            },
          };
          onChange(syntheticEvent, newVal);
        }
      }
    } else {
      setInputValue(newVal);
      if (onChange) {
        const syntheticEvent = {
          target: {
            value: newVal,
            name: e.target.name,
          },
        };
        onChange(syntheticEvent, newVal);
      }
    }
  }
  const handleInputOnBlur = (e) => {
    let newVal = changeCase ? e.target.value.toString()?.toUpperCase() : e.target.value;
    if (isSpecficText && regePattern !== '') {
      let checkText = new RegExp(regePattern);
      if (checkText.test(newVal)) {
        setInputValue(newVal);
        if (onBlur) {
          const syntheticEvent = {
            target: {
              value: newVal,
              name: e.target.name,
            },
          };
          onBlur(syntheticEvent, newVal);
        }
      }
    } else {
      setInputValue(newVal);
      if (onBlur) {
        const syntheticEvent = {
          target: {
            value: newVal,
            name: e.target.name,
          },
        };
        onBlur(syntheticEvent, newVal);
      }
    }
  };

  const labelTxt = isCompulsory ? (
    <span>
      {label}
      <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
    </span>
  ) : (
    label
  );

  const clearInput = (e) => {
    setInputValue("");
    if (onChange) {
      onChange(e);
    }
  };

  const handleWheel = (e) => {
    if (type === "number") {
      e.preventDefault(); // Prevent default behavior of scrolling changing the value
      e.target.blur();
    }
  };

  const handleKeyDown = (e) => {
    if (type === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.preventDefault(); // Prevent up and down keys from changing the value
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };
  return (
    <CssTextField
      fullWidth
      type={type}
      name={name}
      id={id === '' ? name : id}
      label={labelTxt}
      disabled={disabled}
      value={inputValue}
      onChange={handleInputOnChange}
      size="small"
      inputRef={textBoxRef}
      sx={style}
      onBlur={handleInputOnBlur}
      onFocus={(e) => {
        onFocus && onFocus(e)
      }}
      onKeyDown={(e) => {
        handleKeyDown(e)
      }}
      onWheel={handleWheel} // Add event listener to prevent mouse wheel behavior
      InputProps={{
        autoComplete: "off",
        startAdornment: adornment ? (
          calIcon ? (
            <InputAdornment position="start">
              <FontAwesomeIcon
                icon={faCalendarDays}
                className="cross"
                style={{ fontSize: "18px" }}
                color={"#0085fe"}
              />
            </InputAdornment>
          ) : rssign ? (
            "Rs"
          ) : null
        ) : null,
        endAdornment: adornment ? (
          disabled ? null : (
            <InputAdornment position="end">
              {inputValue && inputValue.length > 0 && (
                <div className="cross--icon">
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="cross"
                    onClick={clearInput}
                  />
                </div>
              )}
            </InputAdornment>
          )
        ) : null,
      }}
      inputProps={
        type === "number" ? { max: maxLength } : { maxLength: maxLength }
      }
    />
  );
}

export default TextBox;
